import { TOPICS, CATEGORY_ORDER } from '../data/topics.js';
import { PROJECTS } from '../data/projects.js';

export function buildMenu(onProjectClick, onFilterChange) {
  const menu = document.getElementById('menu');
  const byTopic = {};
  PROJECTS.forEach(p => {
    (byTopic[p.topic] ||= []).push(p);
  });

  CATEGORY_ORDER.forEach(topicKey => {
    const list = byTopic[topicKey];
    if (!list || !list.length) return;
    const topic = TOPICS[topicKey];
    const cat = document.createElement('div');
    cat.className = 'category';
    cat.innerHTML = `
      <div class="category-header">
        <span style="color:${topic.hex}">${topic.name}</span>
        <span class="count">${list.length}</span>
      </div>
      ${list.map(p => `
        <div class="project-item" data-id="${p.id}">
          <span class="dot" style="background:${topic.hex}; color:${topic.hex}"></span>
          <span class="name">${p.name}</span>
          ${p.featured ? '<span class="featured-badge" title="Featured">★</span>' : ''}
        </div>
      `).join('')}
    `;
    menu.appendChild(cat);
  });

  const chips = document.createElement('div');
  chips.id = 'topic-chips';
  chips.innerHTML = `
    <div class="chip active" data-topic="all">All</div>
    ${CATEGORY_ORDER.map(k => {
      const t = TOPICS[k];
      return `<div class="chip" data-topic="${k}" style="color:${t.hex}">${t.short}</div>`;
    }).join('')}
  `;
  menu.appendChild(chips);

  document.querySelectorAll('.project-item').forEach(item => {
    item.addEventListener('click', () => onProjectClick(item.dataset.id));
  });
  document.querySelectorAll('.chip').forEach(chip => {
    chip.addEventListener('click', () => {
      onFilterChange(chip.dataset.topic);
      document.querySelectorAll('.chip').forEach(c => c.classList.toggle('active', c === chip));
    });
  });
}

export function markVisited(id) {
  document.querySelectorAll('.project-item').forEach(el => {
    if (el.dataset.id === id) el.classList.add('visited', 'active');
    else el.classList.remove('active');
  });
}

export function clearActive() {
  document.querySelectorAll('.project-item.active').forEach(el => el.classList.remove('active'));
}

export function setActiveChip(topic) {
  document.querySelectorAll('.chip').forEach(c => c.classList.toggle('active', c.dataset.topic === topic));
}
